// extracted by mini-css-extract-plugin
export var close = "EventBanner-module--close--2nnQw";
export var cta = "EventBanner-module--cta--kO1se";
export var date = "EventBanner-module--date--4q81S";
export var isOpen = "EventBanner-module--isOpen--4zi3F";
export var label = "EventBanner-module--label--Knjpc";
export var left = "EventBanner-module--left--VAIoJ";
export var location = "EventBanner-module--location--EbPcY";
export var right = "EventBanner-module--right--KYUE5";
export var root = "EventBanner-module--root--0i7w0";
export var subtitle = "EventBanner-module--subtitle--Nc9r7";
export var text = "EventBanner-module--text--1Wpmh";
export var title = "EventBanner-module--title--9VpYe";